import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { fetchAssortment } from 'b2b-apps/shop/assortment/redux/actionCreators';
import { getAssortment } from 'b2b-apps/shop/assortment/redux/selectors';
import { AssortmentCategoryType } from 'b2b-apps/shop/assortment/redux/types';
import { RemoteRecord } from 'b2b-apps/shop/common/redux/RemoteRecord';

type UseAssortmentReturnType = RemoteRecord<AssortmentCategoryType[]>;

const useAssortment = (): UseAssortmentReturnType => {
  const dispatch = useDispatch();
  const content = useSelector(getAssortment);

  useEffect(
    (): void => {
      if (!content.isLoaded) {
        dispatch(fetchAssortment());
      }
    },
    [content.isLoaded, dispatch],
  );

  return content;
};

export {
  useAssortment,
};
export type {
  UseAssortmentReturnType,
};
